import React, { ReactNode } from 'react';
import Stack from '@mui/material/Stack';

type CardsContainerProps = {
  children: ReactNode;
  index?: number;
};

export const CardsContainer: React.FunctionComponent<CardsContainerProps> = ({ children }) => (
  <Stack
    direction="row"
    flexWrap="wrap"
    width="100%"
    sx={{
      columnGap: { lg: '42px', md: '20px', sm: '8px', xs: '8px' },
      rowGap: { lg: '43px', md: '20px', sm: '8px', xs: '8px' },
      justifyContent: { md: 'flex-start', sm: 'center', xs: 'center' },
      position: 'relative',
      height: '100%',
    }}
  >
    {children}
  </Stack>
);
